import {
  getErrors,
  loading,
  setOnSuccessUpdatePassword,
  setOnSuccessUpdateProfile,
  setOnSuccessUploadBanner,
  setOnSuccessUploadLogo,
  setOrgPaymentProviders,
  setPaginator,
  setPaymentProviders,
  setProfile,
  setSenderEmail,
  setUpdatedState,
  setWebsite,
  setWithdraw,
  setWithdrawHistories,
} from '@/reducers/profile';
import { headers } from '@/services/headers';
import { ThunkAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '../store';

export const ShowProfile =
  (): ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .get(process.env.REACT_APP_BASE_URL + '/org/profile', {
        headers: headers(),
      })
      .then((response) => {
        dispatch(setProfile(response.data.data));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const UploadProfileBanner =
  (image?: File): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .post(
        process.env.REACT_APP_BASE_URL + '/org/profile/banner',
        {
          image: image,
        },
        {
          headers: { ...headers(), 'Content-Type': 'multipart/form-data' },
        }
      )
      .then((response) => {
        dispatch(setOnSuccessUploadBanner(true));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });

    return response;
  };

export const UploadProfileLogo =
  (image?: File): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .post(
        process.env.REACT_APP_BASE_URL + '/org/profile/logo',
        {
          image: image,
        },
        {
          headers: { ...headers(), 'Content-Type': 'multipart/form-data' },
        }
      )
      .then((response) => {
        dispatch(setOnSuccessUploadLogo(true));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });

    return response;
  };

export const UpdateProfile =
  (profile: any): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .patch(process.env.REACT_APP_BASE_URL + '/org/profile', profile, {
        headers: headers(),
      })
      .then((response) => {
        dispatch(setOnSuccessUpdateProfile(true));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });

    return response;
  };

export const UpdatePassword =
  (formData: any): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .patch(
        process.env.REACT_APP_BASE_URL + '/org/profile/password',
        formData,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setOnSuccessUpdatePassword(response.data.message));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });

    return response;
  };

export const GetPaymentProviders =
  (query?: string, page = 1): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .get(
        process.env.REACT_APP_BASE_URL +
          `/helpers/payment-providers?filter[search]=` +
          query +
          '&page=' +
          page,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setPaymentProviders(response.data.data));
        dispatch(setPaginator(response.data.meta));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const GetOrgPaymentProviders =
  (query?: string, page = 1): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .get(
        process.env.REACT_APP_BASE_URL +
          `/org/settings/payment-providers?filter[search]=` +
          query +
          '&page=' +
          page,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setOrgPaymentProviders(response.data.data));
        dispatch(setPaginator(response.data.meta));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const StorePaymentProviders =
  (formData: any): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .post(
        process.env.REACT_APP_BASE_URL + '/org/settings/payment-providers',
        formData,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setUpdatedState(Math.random()));
        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const UpdatePaymentProviders =
  (id: string, formData: any): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .post(
        process.env.REACT_APP_BASE_URL +
          '/org/settings/payment-providers/' +
          id,
        formData,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setUpdatedState(Math.random()));
        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const GetOrganizerWithdraws =
  (query?: string, page = 1): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    return axios
      .get(
        process.env.REACT_APP_BASE_URL +
          `/org/settings/withdraws?filter[search]=` +
          query +
          '&page=' +
          page,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setWithdrawHistories(response.data.data));
        dispatch(setPaginator(response.data.meta));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });
  };

export const ApproveOrganizerWithdraw =
  (withdrawId: string): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    return axios
      .patch(
        process.env.REACT_APP_BASE_URL +
          '/org/settings/withdraws/' +
          withdrawId,
        {},
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setWithdraw(response.data.data));
        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });
  };

export const ShowWebsite =
  (): ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .get(process.env.REACT_APP_BASE_URL + '/org/settings/websites', {
        headers: headers(),
      })
      .then((response) => {
        dispatch(setWebsite(response.data.data));
        dispatch(setSenderEmail(response.data.data.sender_email));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const UpdateWebsite =
  (website: any): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .patch(
        process.env.REACT_APP_BASE_URL + `/org/settings/websites/${website.id}`,
        website,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setOnSuccessUpdateProfile(true));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });

    return response;
  };

export const UploadWebsiteLogo =
  (websiteId: any, image?: File): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .post(
        process.env.REACT_APP_BASE_URL +
          `/org/settings/websites/${websiteId}/logo`,
        {
          image: image,
        },
        {
          headers: { ...headers(), 'Content-Type': 'multipart/form-data' },
        }
      )
      .then((response) => {
        dispatch(setOnSuccessUploadLogo(true));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });

    return response;
  };

export const UploadWebsiteBanner =
  (websiteId: any, images?: any): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .post(
        process.env.REACT_APP_BASE_URL +
          `/org/settings/websites/${websiteId}/banners`,
        {
          images: images,
        },
        {
          headers: { ...headers(), 'Content-Type': 'multipart/form-data' },
        }
      )
      .then((response) => {
        dispatch(setOnSuccessUploadBanner(true));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });

    return response;
  };

export const DeleteWebsiteBanner =
  (websiteId: any, bannerId: any): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .delete(
        process.env.REACT_APP_BASE_URL +
          `/org/settings/websites/${websiteId}/banners/${bannerId}`,
        {
          headers: { ...headers(), 'Content-Type': 'multipart/form-data' },
        }
      )
      .then((response) => {
        dispatch(setOnSuccessUploadBanner(true));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });

    return response;
  };

export const UpdateSenderEmail =
  (
    website: any,
    senderEmail: any
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .patch(
        process.env.REACT_APP_BASE_URL +
          `/org/settings/websites/${website.id}/sender-emails/${senderEmail.id}`,
        senderEmail,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setOnSuccessUpdateProfile(Math.random()));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });

    return response;
  };
